

export const PrivatePath = {
  home: "/home",
  create: "/create-appointment",
  services: "/services",
  staff: "/staff",
  attendence:"/attendence",
  analytics:"/analytics-reports",
  customerDetails:"/customer-details",
  pos:"/pos",
  manageStores:"/manage-stores",
};
export const PublicPath = {
  login: "/login",
  // register: "/sign-up",
  userVerify:"/user-verify"
};
